var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"py-6",attrs:{"tile":"","flat":""}},[_c('div',{staticClass:"mx-auto text-center"},[_c('div',{staticClass:"font-weight-light my-2"},[_vm._v(" Authorised and regulated by the Financial Conduct Authority: 531127 ")]),_c('small',[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+" Mercury Foreign Exchange Limited ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }